import { BuildingId, OrgId } from 'app/common/types/id'
import { getFilterWarehouseStock } from 'app/filters/_api/getFilterWarehouseStock'

import { useFilterStore } from './store'
import { FilterValues } from './store/types'
import { calculateVisibility } from './visibilityRules'

let handleApply: (state: FilterValues) => void = () => {}

/**
 * 🌵 Начальная инициализация
 */
async function initialize({
  external,
  onApply,
}: {
  external?: FilterValues
  onApply?: (state: FilterValues) => void
} = {}) {
  if (onApply) handleApply = onApply
  const store = useFilterStore.getState()
  store.setReady(false)
  store.setOptions({})

  store.setLoading('orgs', true)

  const options = await getFilterWarehouseStock()
  const { orgs, buildingsByOrgId, isCentralWarehouse } = options

  store.setLoading('orgs', false)

  store.setOptions({ orgs, buildingsByOrgId, isCentralWarehouse })
  store.setDefaults({})

  if (external) store.setDraft(external)
  else store.resetDraft()
  store.applyDraft()

  store.setReady(true)
}

/**
 * 🌵 Выбор заведений
 */
async function selectDraftOrg(orgId?: OrgId) {
  const store = useFilterStore.getState()

  const actual = calculateVisibility({ ...store.draft, ...store.options, orgId })

  store.setDraft({ orgId })

  if (actual.buildings) {
    store.setDraft({ buildingId: undefined })
    store.applyDefaultsByKey('buildingId')
    store.resetDraftByKey('buildingId')
  }
}

/**
 * 🌵 Выбор корпуса
 */
async function selectDraftBuilding(buildingId?: BuildingId) {
  const store = useFilterStore.getState()

  store.setDraft({ buildingId })
}

/**
 * 🌵 Применение фильтров
 */
function apply() {
  const store = useFilterStore.getState()
  store.applyDraft()
  handleApply(store.applied)
}

/**
 * 🌵 Сброс всех фильтров на значения по умолчанию
 */
async function resetToDefaults() {
  const store = useFilterStore.getState()
  store.resetDraft()
  store.applyDraft()
}

export const filterActions = {
  initialize,
  selectDraftOrg,
  selectDraftBuilding,

  apply,
  resetToDefaults,
}
